export default __webpack_public_path__ + "static/media/sarah.9bf6cf56.jpg";